import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import IconSvg from 'src/components/common/ui/IconSvg';
import { AuthContext } from 'src/contexts';

const LaunchProject = () => {
    const navigate = useNavigate();
    const { profile } = useContext(AuthContext);

    const handleLaunch = () => {
        if (profile?.facebook) {
            navigate('/dashboard/create-campaign');
        } else {
            navigate('/dashboard/account-setup');
        }
    };

    return (
        <div
            className="p-96 border border-gray-200 shadow-sm flex items-center justify-center bg-no-repeat bg-center bg-contain h-[500px] w-full rounded-[24px]"
            style={{
                backgroundImage: `url('/assets/images/launch-bg.png')`,
            }}
        >
            <div className="text-center relative">
                <h1
                    className="text-[96px] leading-[1] font-semibold text-black mb-12 py-px"
                    style={{ fontFamily: 'Figtree' }}
                >
                    Ready?
                </h1>

                <div className="relative inline-block -mt-10 -ml-6">
                    <button
                        onClick={handleLaunch}
                        className="text-white bg-blue-600 hover:bg-blue-700 relative z-10 shadow-lg"
                        style={{
                            width: '619.67px',
                            height: '132px',
                            borderRadius: '24.44px',
                            paddingTop: '34.22px',
                            paddingBottom: '34.22px',
                            paddingLeft: '58.67px',
                            paddingRight: '58.67px',
                            fontFamily: 'Inter',
                            fontWeight: 500,
                            fontSize: '44px',
                            lineHeight: '56.22px',
                            letterSpacing: '-0.01em',
                            textAlign: 'center',
                        }}
                    >
                        Launch Project
                    </button>

                    <div className="absolute -bottom-12 -right-0 z-20 pointer-events-none drop-shadow-[0_0_12px_white]">
                        <IconSvg icon="mouse" />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default LaunchProject;
